export default __webpack_public_path__ + "img/bYWUaScm.3fa1147a.svg";